/* src/app/account/account-allocations/facility/facility.component.scss */
/*# sourceMappingURL=facility.component.css.map */
